/**
 * Lightweight store for passing React nodes (JSX) to the signup modal.
 * location.state must be serializable, so JSX is stored here instead
 * and consumed once when the SignUp component mounts.
 */
let _promptNode = null;

export const setPromptNode = node => {
  _promptNode = node;
};

export const consumePromptNode = () => {
  const node = _promptNode;
  _promptNode = null;
  return node;
};
